<template>
    <div class="block block-bordered">
        <div class="block-header block-header-default">
            <div class="block-title">
                <h2 class="content-heading">Salary Advance Employees</h2>
            </div>
        </div>

        <div class="block-content">
            <el-table
                :data="items.filter(data => !search || data.names.toLowerCase().includes(search.toLowerCase()))"
                style="width: 100%">
                <el-table-column
                    label="ID Number"
                    prop="id_number">
                </el-table-column>
                <el-table-column
                    label="MSIDN"
                    prop="msisdn">
                </el-table-column>
                <el-table-column
                    label="Name"
                    prop="names">
                </el-table-column>
                <el-table-column
                    align="right">
                    <template slot="header" slot-scope="scope">
                        <el-input
                            v-model="search"
                            size="mini"
                            placeholder="Type to search Name"/>
                    </template>
                    <template slot-scope="scope">
                        <el-button
                            size="mini"
                            @click="handleView(scope.$index, scope.row)">View
                        </el-button>
                        <!--                        <el-button-->
                        <!--                            size="mini"-->
                        <!--                            type="danger"-->
                        <!--                            @click="handleDelete(scope.$index, scope.row)">Delete-->
                        <!--                        </el-button>-->
                    </template>
                </el-table-column>
            </el-table>

            <el-dialog title="User Profile" :visible.sync="dialogTableVisible">
                <el-table :data="profile_items" style="width: 100%">
                    <el-table-column property="data.email" label="Profile" style="width: 100%">
                        <template slot-scope="props">
                            <p>Email: {{ getSafe(() =>props.row.data.email) }}</p>
                            <p>Last Loan Amount: {{ getSafe(() =>props.row.data.lastLoanDetails.amount_requested) }}</p>
                            <p>Senti Limit: {{ getSafe(() =>props.row.data.creditRating.max_range) }}</p>
                            <p>CRB Status: {{ getSafe(() =>props.row.data.crb_pass_status) }}</p>
                            <p>Has defaulted Before: {{ getSafe(() =>props.row.data.is_defaulter) }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import {APP_CONFIG} from "../../config";
    import {Loading} from 'element-ui';
    import {Message} from 'element-ui';

    export default {
        name: "SalaryAdvanceRequests",
        data: function () {
            return {
                employee_number: '',
                name: '',
                position: '',
                amount: '',
                msisdn: '',
                id_number: '',
                snackbar_message: '',
                items: [],
                profile_items: [],
                dialogTableVisible: false,
                search: '',
            }
        },
        mounted() {
            var app = this;
            this.getRequests();
        },
        methods: {
            getRequests() {
                var app = this;
                let formData = new FormData();
                let loadingInstance = Loading.service({fullscreen: true});

                formData.append('project', this.$route.params.project);

                return axios.post(`${APP_CONFIG.URL}projects/` + this.$route.params.project + `/salary_advance/get_employees`,
                    formData
                ).then(function (resp) {
                    console.log('SUCCESS!!');
                    console.log('Response!!' + JSON.stringify(resp.data.data));
                    loadingInstance.close();
                    app.items = app.getSafe(() => resp.data.data);
                    Message.success('Salary Advance Requests Fetched.');
                }).catch(error => {
                    console.log(error.response);
                    console.log("Status Response " + error.response.data.message);
                    Message.error(error.response.data.message);
                    loadingInstance.close();
                }).catch(function (resp) {
                    console.log('FAILURE!!');
                    loadingInstance.close();
                });
            },
            getSafe(fn) {
                try {
                    return fn();
                } catch (e) {
                    return undefined;
                }
            },
            handleView(index, row) {
                console.log(index, row);
                console.log("Row " + JSON.stringify(row.id_number));
                console.log("Index " + JSON.stringify(row));

                var app = this;
                let formData = new FormData();
                let loadingInstance = Loading.service({fullscreen: true});

                formData.append('project', this.$route.params.project);
                formData.append('msisdn', row.msisdn);
                formData.append('id_number', row.id_number);

                return axios.post(`${APP_CONFIG.URL}projects/` + this.$route.params.project + `/salary_advance/get_profile`,
                    formData
                ).then(function (resp) {
                    console.log('SUCCESS!!');
                    console.log('Profile Response!!' + JSON.stringify(resp.data.data));
                    loadingInstance.close();
                    app.profile_items = app.getSafe(() => resp.data.data);
                    app.dialogTableVisible = true;
                    Message.success('Employee Profile Fetched.');
                }).catch(error => {
                    console.log(error.response);
                    console.log("Status Response " + error.response.data.message);
                    Message.error(error.response.data.message);
                    loadingInstance.close();
                }).catch(function (resp) {
                    console.log('FAILURE!!');
                    loadingInstance.close();
                });
            },
            handleDelete(index, row) {
                console.log(index, row);
            }
        }
    }
</script>

<style scoped>

</style>
